import React from "react";
import { Link } from "react-router-dom";

const Nav = () => {
  return (
    <div className="main-menu text-center hidden xl:block">
      <nav className="pl-4">
        <ul className="flex gap-4 font-bold">
          <li>
            <Link to={ `/`}>Home</Link>
          </li>
          <li>
            <Link to={ `/about`}>About</Link>
          </li>
          <li>
            <Link to={ `/services`}>Services</Link>
          </li>
          <li>
            <Link to={ `/portfolio`}>Portfolio</Link>
          </li>
      {/*     <li>
            <Link to={ `/testimonials`}>
              Testimonials
            </Link>
          </li> */}
          <li>
            <Link to={ `/contact`}>Contact</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Nav;
